import { prepareQueryParameter } from './search_utils/search_utils';

export const prepareUrlQuery = (query: string | undefined) => {
  if (!query) {
    return query;
  }
  // Special handling of URLs. We want to allow searching for share URLs but in this
  // case we can not lower case it or add asterisks to the query because we need to
  // perform an exact match
  if (query.startsWith('https://')) {
    return query;
  }
  return prepareQueryParameter(query, { addAsteriskOnlyToEndOfQuery: true });
};
